/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 825
// module chunks = 2